import MdaeTreeView from "./component";
import { ITreeViewOptions } from "devextreme-react/tree-view";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeTreeView extends ITreeViewOptions {
  id: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeTreeView;
